import { render, staticRenderFns } from "./Vol04.vue?vue&type=template&id=ae96c0be&scoped=true&"
import script from "./Vol04.vue?vue&type=script&lang=js&"
export * from "./Vol04.vue?vue&type=script&lang=js&"
import style0 from "./Vol04.vue?vue&type=style&index=0&id=ae96c0be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae96c0be",
  null
  
)

export default component.exports